// extracted by mini-css-extract-plugin
export default {"footerNav":"Footer_footerNav__Dlb5f"};